const my_profile = {
  viewMyClubSeacretProfile: "Ver Perfil do Meu ClubeSeacret", // translated
  viewMoreDetails: "Ver mais detalhes", // translated
  unverifiedEmail: "E-mail não verificado", // translated
  verifiedEmail: "E-mail verificado", // translated
  createdFrom: "Criado a partir de", // translated
  createdTo: "Criado até", // translated
  selectStatus: "Selecionar status...", // translated
  searchByTitle: "Pesquisar por título...", // translated
  pushNotifications: "Não empurre", // translated 
  pushNotificationsDescription: "Receba notificações do navegador para atualizações e eventos importantes", // translated 
  pushNotificationsNotSupported: "As notificações push não são suportadas neste navegador", // translated 
  pushNotificationsDeniedMessage: "A permissão de notificação foi negada. Por favor, ative as notificações nas configurações do navegador para receber notificações push.", // translated 
  pushNotificationsEnabled: "Notificações push habilitadas com sucesso", // translated 
  pushNotificationsDisabled: "Notificações push desabilitadas com sucesso", // translated 
  userInformationMissing: "Informações do usuário estão faltando", // translated 
  failedToUpdatePushNotifications: "Falha ao atualizar as configurações de notificações push", // translated 
  notificationPermissionDenied: "A permissão de notificação foi negada. Por favor, ative as configurações do navegador.", // translated 
  notificationPermissionRequired: "A permissão de notificação é necessária para ativar notificações push", // translated 
  notSupported: "Não suportado", // translated 
  permissionDenied: "Permissão negada", // translated 
  permissionNotRequested: "Permissão não solicitada", // translated 
  enabled: "Habilitado", // translated 
  disabled: "Desabilitado", // translated 
};


export default my_profile;
